export class ImpactAssessmentT6ListDto{
    id : number;
    updatedDB_Id :number;
    isMerged: boolean;
    merged_Id :string;
    previousImpactAsss_Id :string;
    updatedDB_Date :Date;
    geography :string;
    mappingID :string;
    country :string;
    regulator :string;
    pubType :string;
    title :string;
    description :string;
    hyperlink :string;
    ruleTopic :string;
    linkedRules :string;
    linkedRulesByRegulator:string; 
    linkedPolicies :string;
    linkedRisks :string;
    linkedProcesses :string;
    implementationStatus:string
    category :string;
    ruleType :string;
    applicationDate :Date;
    jurisdiction :string;
    assessmentTeam :string;
    assessor :string;
    summary :string;
    initialImpactAssessment :string;
    impactRating :string;
    assessmentDueDate :Date;
    currentAssessmentStatus :string;
    assessmentLastEdited :Date;
    isReviewRequired :boolean;
    reviewTeam :string;
    stakeholder :string;
    stakeholderStatus :string;
    stakeholderImpactAssessment :string; 
    reviewDetails :string;
    reviewDueDate :Date;
    reviewLastEdited :Date;
    stakeholderImpactRating :string;
    isImplementationRequired :boolean;
    implementationDueDate :Date;
    implementationLastEdited :Date;
    implementationDetails :string;
    versionNumber :number;
    userId :string;
    userName :string;
    created :Date;
    jurisdictionId:number; 
     isRecordTime :boolean;
     timeSpent  :number;
    isSendNotification  :boolean;   
     templateNo:number;  
     assessorImpactRating:string;
     assessmentStatusId:number;
   constructor(){
    this.id =0;
    this.updatedDB_Id =0;
    this.isMerged =false;
    this.merged_Id ="";
    this.previousImpactAsss_Id ="";
    this.updatedDB_Date =new Date();
    this.geography ="";
    this.mappingID ="";
    this.country ="";
    this.regulator ="";
    this.pubType ="";
    this.title ="";
    this.description=""; 
    this.hyperlink ="";
    this.ruleTopic ="";
    this.linkedRules ="";
    this.linkedRulesByRegulator ="";
    this.linkedPolicies ="";
    this.linkedRisks ="";
    this.linkedProcesses ="";
    this.category ="";
    this.ruleType ="";
    this.applicationDate = new Date();
    this.jurisdiction ="";
    this.assessmentTeam ="";
    this.assessor="";
    this.summary ="";
    this.initialImpactAssessment ="";
    this.impactRating =""
    this.assessmentDueDate = new Date();
    this.currentAssessmentStatus=""; 
    this.implementationStatus= "";
    this.assessmentLastEdited = new Date();
    this.isReviewRequired =false;
    this.reviewTeam ="";
    this.stakeholder=""; 
    this.stakeholderStatus=""; 
    this.stakeholderImpactAssessment ="";
    this.reviewDetails ="";
    this.reviewDueDate = new Date();
    this.reviewLastEdited = new Date();
    this.stakeholderImpactRating ="";
    this.isImplementationRequired  = false;
    this.implementationDueDate = new Date();
    this.implementationLastEdited = new Date();
    this.implementationDetails ="";
    this.versionNumber =0;
    this.userId ="";
    this.userName = "";
    this.created = new Date();
    this.jurisdictionId= 0;
    this.isRecordTime  = false;
    this.timeSpent =0; 
    this.isSendNotification = false;   
    this.templateNo = 0;
    this.assessorImpactRating = "";
    this.assessmentStatusId = 0;
   }  
}